// extracted by mini-css-extract-plugin
export var richText = "richText-module--richText--a06fa";